import React from 'react';
import { withSvg } from './Svg';

const SvgLockup = () => (
  <>
  </>
);

export default withSvg(249, 40)(SvgLockup);
